import React from 'react';

import { Link } from 'react-router-dom';

import { Mail } from 'lucide-react';

function Newsletter() {
  return (
    <div className="bg-[#EAEAEA] py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <Mail className="h-12 w-12 text-[#003366] mx-auto mb-4" />
          <h2 className="text-3xl font-bold text-[#003366] mb-4">Suscríbete a nuestro boletín</h2>
          <p className="text-gray-600 mb-8">
            Recibe las últimas noticias y actualizaciones sobre tecnología e industria
          </p>
          <div className="max-w-md mx-auto">
            <Link
              to="/contacto"
              state={{
                subject: 'Suscripción al Newsletter',
                message:
                  'Me gustaría suscribirme al newsletter para recibir las últimas noticias y actualizaciones sobre tecnología e industria.\n\nPor favor, agrégame a la lista de suscriptores.',
              }}
              className="bg-[#003366] text-white px-8 py-3 rounded-lg hover:bg-[#002244] transition-colors inline-block"
            >
              Suscribirse
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Newsletter;
